"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetTmpId = exports.addTmpId = void 0;
const uuid_1 = require("uuid");
/** Don't touch if exist. Add if not exist */
const addTmpId = (value) => {
    if ('tmpId' in value && typeof value.tmpId === 'string') {
        return value;
    }
    return {
        ...value,
        tmpId: (0, uuid_1.v4)(),
    };
};
exports.addTmpId = addTmpId;
/** Overwrite tmpId */
const resetTmpId = (value) => ({
    ...value,
    tmpId: (0, uuid_1.v4)(),
});
exports.resetTmpId = resetTmpId;
//# sourceMappingURL=tmpId.js.map